import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../../../common/SharedComponents';
import { LoanPageType, LoanStatusType } from '../../../../../loans/common/LoanConstants';
import LoansLandingPageOutstanding from '../../../../../loans/LoansLandingPageOutstanding';
import { LoansWorkspacePage } from '../../../../../loans/LoansWorkspacePage/LoansWorkspacePage';

export default function LoansOutstandingRoutes() {
    return (
        <>
            <Route
                path='/loans/outstanding/loc'
                element={
                    <RequireAdmin>
                        <LoansLandingPageOutstanding pageType={LoanPageType.LOC} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/outstanding/construction'
                element={
                    <RequireAdmin>
                        <LoansLandingPageOutstanding pageType={LoanPageType.Construction} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/outstanding/rental'
                element={
                    <RequireAdmin>
                        <LoansLandingPageOutstanding pageType={LoanPageType.Rental} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/outstanding/buildrent'
                element={
                    <RequireAdmin>
                        <LoansLandingPageOutstanding pageType={LoanPageType.BuildRent} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/outstanding/fixflip'
                element={
                    <RequireAdmin>
                        <LoansLandingPageOutstanding pageType={LoanPageType.FixFlip} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/outstanding/land'
                element={
                    <RequireAdmin>
                        <LoansLandingPageOutstanding pageType={LoanPageType.Land} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/outstanding/model'
                element={
                    <RequireAdmin>
                        <LoansLandingPageOutstanding pageType={LoanPageType.Model} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/outstanding/bridge'
                element={
                    <RequireAdmin>
                        <LoansLandingPageOutstanding pageType={LoanPageType.Bridge} />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/outstanding'
                element={
                    <RequireAdmin>
                        <LoansWorkspacePage status={LoanStatusType.Outstanding} />
                    </RequireAdmin>
                }
            />
        </>
    );
}
